import script from "./PrintYourArt.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintYourArt.vue?vue&type=script&setup=true&lang=js"

import "./PrintYourArt.vue?vue&type=style&index=0&id=01da245b&lang=css"

const __exports__ = script;

export default __exports__